<template>
<div>
	<div></div>
	<div>
		<input type="text" id="title" class="fadeIn first" name="title" placeholder="Title" v-model="project.title">
		<textarea id="description" class="fadeIn second" name="description" placeholder="Descritpion" v-model="project.description"></textarea>
		<div v-if="isEdit">
			<select class="form-control" v-model="newFieldType">
				<option value="TEXT">Text</option>
				<option value="MULTILINE-TEXT">Multi-line Text</option>
				<option value="URL">URL</option>
				<option value="DATE">Date</option>
			</select>
			<b-button variant="primary" @click="addField">Add New Field</b-button>
			<span v-if="project.fields">
				<table>
					<thead>
						<th>Name</th><th>Value</th><th></th>
					</thead>
					<tr v-for="field in project.fields" v-bind:key="field.id">
						<td>
							<input type="text" class="form-control" v-model="field.name" @change="saveField(field)">				
						</td>
						<td>
							<input type="text" class="form-control" v-model="field.value" @change="saveField(field)">				
						</td>
						<td><b-button variant="danger" @click="deleteField(field)">X</b-button></td>
					</tr>
				</table>
			</span>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'ProjectCreateEditWidget',
	props: {
	mode: String,
	project:{
		type: Object,
		default(){
			return {
				title:"",
				description:"",
				fields:[]
			};
		}
	}
	},
	data(){
	return {
		updating:{},
		initialValues:{},
		newFieldType:"TEXT",
	}
	},
	mounted(){
	if(this.isEdit){
		this.initialValues=Object.assign({}, this.project);
		this.$parent.$parent.onOk=this.doUpdate;
		this.$parent.$parent.onCancel=this.cancelUpdate;
		this.updating.id=this.project.id;
	}
	else
		this.$parent.$parent.onOk=this.doCreate;
	},
	computed:{
	isEdit(){
		return this.mode!="create";
	}
	},
	methods:{
		doCreate:async function(){
			let response=await this.$API.apiPOST("/projects", 
			{
				title: this.project.title,
				description: this.project.description
			},
			true
			);
			this.$parent.$parent.hide();
			this.$router.push("/project/" + response.projectID);
		},
		doUpdate: async function(){
			let response=await this.$API.apiPATCH("/projects", this.updating, true);
			this.$parent.$parent.hide();
		},
		cancelUpdate(){
			//Not needed, but good thing, tho
			//this.$emit('updateCanceled');
			//v-on:updateCanceled="loadProject"
			Object.keys(this.initialValues).forEach((k)=>{
				this.project[k]=this.initialValues[k];
			});
			this.$parent.$parent.hide();
		},
		async addField(){
			let response = await this.$API.apiPOST("/project/field", { projectID: this.project.id, type: this.newFieldType }, true);
			if(response.status=="success")
				this.project.fields.push(response.field);
		},
		async saveField(field){
			let response = await this.$API.apiPATCH("/project/field", { field: field }, true);
		},
		async deleteField(field){
			let idx = this.project.fields.indexOf(field);
			this.$delete(this.project.fields, idx);
			let response = await this.$API.apiDELETE("/project/field", { field: field }, true);
		}
	},
	watch:{
		'project.title':function(val){
			this.updating.title=val;
		},
		'project.description':function(val){
			this.updating.description=val;
		},
		'project.chatURL':function(val){
			this.updating.chatURL=val;
		},
		'project.trackerURL':function(val){
			this.updating.trackerURL=val;
		},
		'project.storageURL':function(val){
			this.updating.storageURL=val;
		},
		'project.deadline':function(val){
			this.updating.deadline=val;
		},
	}
}
</script>
<style scoped>
	textarea{
	height: 200px;
	text-align: left;
	}
	input[type=text]{
	text-align: left;
	}
</style>